import React from 'react';

export const EmptyCart = () => <div>Cart is empty!</div>;
